module.exports = __webpack_public_path__ + "img/20200613_094835.7f059626.jpg";